import { CommonModule } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EmptyResultComponent, SkeletonCardTableComponent } from '@okcargo-apps/layout-ionic';
import { IFreightBasicForShipper } from '@okcargo-apps/shared-domain';
import { Observable } from 'rxjs';
import { FreightShipperCardComponent } from '../freight-shipper-card/freight-shipper-card.component';
import { FreightShipperService } from '../freight-shipper.service';

@Component({
  selector: 'lib-freight-shipper-inprogress-list',
  templateUrl: './freight-shipper-inprogress-list.component.html',
  styleUrls: ['./freight-shipper-inprogress-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    SkeletonCardTableComponent,
    TranslateModule,
    FreightShipperCardComponent,
    EmptyResultComponent,
  ],
})
export class FreightShipperInprogressListComponent {
  private readonly freightShipService = inject(FreightShipperService);

  public freights$: Observable<IFreightBasicForShipper[]>;

  constructor() {
    this.freights$ = this.freightShipService.freightsShipInProgress$;
  }

  get loading(): boolean {
    return this.freightShipService.freightsShipNotFinishedLoading();
  }
}
